// the iso string representation of today

function addLeadingZero(dateNumber: number): string {
  return dateNumber < 10 ? `0${dateNumber}` : `${dateNumber}`;
}

export const todayDate = new Date();
export const todayISO = `${todayDate.getFullYear()}-${addLeadingZero(todayDate.getMonth() + 1)}-${addLeadingZero(
  todayDate.getDate(),
)}`;
